import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const NoStyledLink = styled(NavLink)`
  text-decoration: none;
  color: black;
`;
